import clsx from 'clsx';
import { ConnectedEventInfo } from 'src/components/Events/ConnectedEventInfo';
import { Stack } from 'src/core/ui';
import { useMatchMedia } from 'src/hooks/useMatchMedia';
import { Event, Performer, Venue } from 'src/WebApiController';

import * as styles from './EventHeader.css';

export const EventHeaderWithActions = ({
  event,
  performer,
  venue,
  actions,
}: {
  event: Event;
  performer?: Performer;
  venue?: Venue;
  actions?: React.ReactNode;
}) => {
  const isMobile = useMatchMedia('mobile');

  return (
    <Stack
      width="full"
      direction="row"
      gap={isMobile ? 's' : 'm'}
      alignItems="center"
      justifyContent="spaceBetween"
      className={clsx(styles.eventHeaderCard, {
        [styles.eventHeaderMobilePadding]: isMobile,
      })}
    >
      <ConnectedEventInfo
        showYear
        showEventDateTbd
        event={event}
        performer={performer}
        venue={venue}
        eventClassName={styles.eventHeaderEventName}
        venueClassName={styles.eventHeaderVenueAndDate}
        eventDateClassName={styles.eventHeaderVenueAndDate}
        hideDetailsIcon
        slimContent
        dateTimeSeparator="@"
        withEventStatus
        truncateTitle
        linkEvent={false}
      />
      {actions}
    </Stack>
  );
};
